import React from 'react';

const CHECKED_COLOR = '#9333ea'; // primary-600

export default function SimpleCheckbox({ isChecked, onChange, size = 'lg', ...props }) {
    const dim = size === 'lg' ? 20 : size === 'sm' ? 14 : 16;
    const isDark = document.documentElement.classList.contains('dark');
    const borderColor = isChecked ? CHECKED_COLOR : (isDark ? '#6B7280' : '#CBD5E0');

    return (
        <label
            onClick={(e) => e.stopPropagation()}
            style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
        >
            <input
                type="checkbox"
                checked={!!isChecked}
                onChange={onChange}
                style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
                {...props}
            />
            <span
                aria-hidden
                style={{
                    width: dim, height: dim, minWidth: dim,
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    borderRadius: 6,
                    border: `2px solid ${borderColor}`,
                    background: isChecked ? CHECKED_COLOR : 'transparent',
                    transition: 'all 0.15s ease',
                }}
            >
                {isChecked && (
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                        <path d="M10.2 1L4.8 8L1 4.2" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}
            </span>
        </label>
    );
}
